export default {
    title: 'Meet the Employee',
    employeeFallback: 'your employee',
    evaluationOf: 'Evaluation of {{employeeName}}',
    errors: {
        loadFailed: 'Failed to load the meeting page',
        loadFailedDescription: 'Unable to retrieve the meeting details. Please try again.',
    },
    tips: {
        title: 'Tips for a successful meeting',
        before: {
            title: 'Before the Meeting',
            item1Title: 'Create a relaxed atmosphere',
            item1Description: 'Choose a quiet space, start with a light conversation.',
            item2Title: 'Prepare your mindset',
            item2Description: 'Let the employee lead - build on what they share.',
        },
        during: {
            title: 'During the Meeting',
            item1Title: 'Listen without correcting',
            item1Description: 'Start by truly listening to their perspective.',
            item2Title: 'No need to conclude',
            item2Description: 'Let it pave the way for future conversations.',
            item3Title: 'Ask thoughtful questions',
            item3Description: 'Explore their experience and challenges.',
            item4Title: 'Show genuine interest',
            item4Description: 'Your openness encourages honesty.',
        },
        after: {
            title: 'After the Meeting - What to Observe',
            item1Description: 'Tone, energy, and level of openness during the discussion.',
            item2Description:
                'References to the meeting in future conversations ("That made me think…", "Since we talked…").',
            item3Description:
                'Possibility to offer more structured support, if the employee wants it.',
            item4Description:
                'Keep the door open for a follow-up meeting in whatever format suits them best.',
        },
        proTipLabel: 'Pro Tip:',
        proTip: "Remember, this is a conversation, not an evaluation. Adapt these guidelines to match your natural style and the employee's needs.",
    },
    transcript: {
        title: 'Turn your meeting into momentum',
        description:
            'Upload your meeting transcript and let Amélio AI distill the key insights, capture action items, and map out the next steps, so your conversations turn into real progress.',
        uploadPrompt: 'Upload your meeting transcript for an AI summary.',
        chooseFile: 'Choose File',
        recapTitle: 'Meeting summary',
        generatedBy: 'Generated by Amélio AI',
        discussedPoints: 'Discussed points',
        decisions: 'Decisions',
        commitments: 'Commitments',
        followUps: 'Follow-ups',
        uploadError: "Couldn't upload the transcript. Please try again.",
        uploadFileTooLarge: 'The file exceeds {{maxFileSizeMb}} MB.',
        uploadUnsupportedFormat:
            "This file type isn't accepted. Import the meeting transcript as a .txt or .md file.",
        recapError:
            'The summary could not be written. Your transcript is kept: try again, or import another one.',
        recapPending: 'Summary being prepared',
        recapUnavailable: 'Summary unavailable for now',
        loadError: 'The transcript could not be loaded for now',
        retry: 'Try again',
        downloadTranscript: 'Download full transcript',
        downloadRecap: 'Download the recap',
        downloadError: 'The transcript could not be downloaded. Try again in a moment.',
        importAnother: 'Import another transcript',
        disclosure:
            'Part of the meeting could not be taken into account; this summary covers only the exchanges that were available.',
        unusableTitle: 'No summary could be produced from this file.',
        unusableBody:
            "Amélio's AI needs a transcript of the conversation: lines of dialogue that each start with the name of the person speaking, for example \"Marie: Let's go over your goals for the year.\" Notes, minutes or a written summary of the meeting can't be used, and neither can a transcript that is too short or that the employee doesn't appear in.",
        ownerUndeterminedTooltip: 'The transcript did not make it clear who committed to this.',
        owner: {
            manager: '{{managerLabel}}',
            employee: 'Employee',
            both: 'Both',
            undetermined: 'Owner to confirm',
        },
    },
    completion: {
        markCompleted: 'Mark review as completed',
        markCompletedError: 'We could not mark this meeting as completed. Please try again.',
        submissionRequiredHint:
            'Submit your assessment answers first to mark this meeting as completed.',
        completed: 'Meeting completed',
        undo: 'Undo',
        completedOn: 'Completed on {{date}}',
        confirmTitle: 'Great job!',
        confirmSubtitle: 'You had a meaningful conversation',
        confirmDescription:
            "Congratulations on a thoughtful and supportive discussion with {{firstName}}. You created space for growth and understanding.\n\nThat's what great conversations are all about! 🌟",
    },
    privacyNotice: {
        title: 'Evaluation meetings are never shared with the employee',
        description:
            'All content, including talking points, meeting plans, action items, and notes, is visible to you and your management line, never to the employee.',
    },
};
